export function SimpleTest() {
  return (
    <div style={{ padding: "20px", backgroundColor: "red", color: "white" }}>
      <h1>Simple Test Component</h1>
      <p>If you can see this, React is working!</p>
      <p>Current time: {new Date().toLocaleString()}</p>
    </div>
  );
}
